"use client";

import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import About from "@/components/About";

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-28 pb-10">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(99,102,241,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(99,102,241,0.04)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] -z-10 opacity-60" />
        
        {/* Story details */}
        <About />

        <div className="max-w-4xl mx-auto px-6 pb-20 font-[var(--font-space-grotesk)] text-gray-300">
          <div className="bg-white/[0.02] border border-white/5 rounded-[2rem] p-8 md:p-10 shadow-2xl space-y-8">
            <div>
              <h2 className="text-xl font-black text-white font-[var(--font-poppins)] uppercase tracking-wider mb-4">
                Core Engineering Credo
              </h2>
              <ul className="space-y-3 text-xs sm:text-sm">
                <li className="flex gap-2">
                  <span className="text-indigo-400 font-bold">01.</span>
                  <span><strong>Simplicity over cleverness:</strong> Code should be easy to read and understand. Maintainable code is better than premature optimizations.</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-indigo-400 font-bold">02.</span>
                  <span><strong>Production-First:</strong> If it runs on your machine but fails in docker orchestration, it is not completed yet. Build pipelines compile static configurations safely.</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-indigo-400 font-bold">03.</span>
                  <span><strong>Data Integrity:</strong> Structure clean SQL schema indexes, enforce primary key constraints, and avoid raw unescaped inputs to ensure system sanity.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
